<template>
<div class="chapter">
<div class="inner_page">
<p class="p2"><span class="sz"> </span></p>
<p class="p2"><span class="sz"> </span></p>
<p class="p3"><span class="sz">All the books in Dave Duncan's <i>The Seventh Sword</i> series  <br/>are available:</span></p>
<p class="p4"><span class="sz"> </span></p>
<p class="p3"><span class="sz">1. The Reluctant Swordsman</span></p>
<p class="p3"><span class="sz">2. The Coming of Wisdom</span></p>
<p class="p3"><span class="sz">3. The Destiny of the Sword</span></p>
<p class="p3"><span class="sz">4. The Death of Nnanji</span></p>
<p class="p4"><span class="sz"> </span></p>
<p class="p3"><span class="sz">For all Dave Duncan books, see: daveduncan.com</span></p>
<p class="p2"><span class="sz"> </span></p>
<p class="p2"><span class="sz"> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section2.vue?1d2528a0